window.AOS = require('AOS');
AOS.init();